<script setup lang="ts">
import { PaginationData } from '@/@types/order'
import { Button } from '@/components/ui/button'
import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationFirst,
    PaginationItem,
    PaginationLast,
    PaginationNext,
    PaginationPrevious,
} from '@/components/ui/pagination'
import { Link } from '@inertiajs/vue3'

interface FilterForm {
    order_id: string
    ticket_category: string
    order_payment_type: string
    order_status: string
    mailing_group: string
    mailing_status: string
    mailing_code: string
    data: () => any
}

const props = defineProps<{
    pagination: PaginationData
    workshopId: number
    form: FilterForm
    currentPage: number
}>()

const emit = defineEmits<{
    'update:currentPage': [page: number]
}>()
</script>

<template>
    <Pagination v-slot="{ page }" :items-per-page="pagination.per_page" :total="pagination.total" show-edges :default-page="props.currentPage">
        <PaginationContent v-slot="{ items }" class="mt-4 flex items-center gap-1">
            <PaginationFirst @click="emit('update:currentPage', 1)" />
            <PaginationPrevious @click="emit('update:currentPage', props.currentPage - 1)" />

            <template v-for="(item, index) in items">
                <PaginationItem v-if="item.type === 'page'" :key="index" :value="item.value" as-child>
                    <Button
                        :as="Link"
                        :href="`/admin/mailings?workshop_id=${props.workshopId}`"
                        class="h-9 w-9 p-0"
                        preserve-state
                        :disabled="item.value === props.currentPage"
                        :data="{ ...props.form.data(), page: item.value }"
                        :variant="item.value === page ? 'default' : 'outline'"
                    >
                        {{ item.value }}
                    </Button>
                </PaginationItem>
                <PaginationEllipsis v-else :key="item.type" :index="index" />
            </template>

            <PaginationNext @click="emit('update:currentPage', props.currentPage + 1)" />
            <PaginationLast @click="emit('update:currentPage', pagination.last_page)" />
        </PaginationContent>
    </Pagination>
</template>
